export default "__VITE_PUBLIC_ASSET__d8e5f5db__"